import {Component, Input, OnInit} from '@angular/core';
import {MailActionModel} from '../../../model/mail.action.model';
import {Constants} from '../../../constants';

@Component({
  selector: 'app-mail-preview',
  templateUrl: './mail-preview.component.html',
  styleUrls: ['./mail-preview.component.scss']
})
export class MailPreviewComponent implements OnInit {
  @Input() action: MailActionModel;
  constructor() { }

  ngOnInit() {
  }
  get recipients() {
    return this.action && this.action.configuration ?
      this.action.configuration.to.split(Constants.COMMA) : [];
  }
  get subject() {
    return this.action && this.action.configuration ? this.action.configuration.subject : '';
  }
  get content() {
    return this.action && this.action.configuration ? this.action.configuration.content : '';
  }
  get cc() {
    return this.action && this.action.configuration ?
      this.action.configuration.cc.split(Constants.COMMA) : [];
  }
  get hasCC() {
    return this.action && this.action.configuration ?
      !!this.action.configuration.cc.split(Constants.COMMA)[0] : false;
  }
}



// WEBPACK FOOTER //
// ./src/app/rules/output/mail/mail-preview/mail-preview.component.ts